import { render, staticRenderFns } from "./MyNavmenu.vue?vue&type=template&id=134c86b8&scoped=true&"
import script from "./MyNavmenu.vue?vue&type=script&lang=js&"
export * from "./MyNavmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c86b8",
  null
  
)

export default component.exports